import type { ParameterTimeSeriesChartResult } from "@/lib/api";
import type { TimeSeriesConfig } from "@/components/graph/graph.types";

/**
 * Ensures every configured chart series has a result entry for linegraph rendering.
 * Missing entries (unsupported at station or fetch skipped) become empty time series.
 * API load failures (`data: null`) are preserved so charts can disable those series.
 */
export function mergeStationTimeseriesChartData(
  timeSeriesConfigs: TimeSeriesConfig[],
  fetched: ParameterTimeSeriesChartResult[],
): ParameterTimeSeriesChartResult[] {
  const byParameterId = new Map(
    fetched.map((result) => [
      result.parameter.id,
      {
        parameter: result.parameter,
        data: result.data,
      } satisfies ParameterTimeSeriesChartResult,
    ]),
  );

  for (const config of timeSeriesConfigs) {
    for (const series of config.series) {
      if (byParameterId.has(series.parameter_id)) continue;

      byParameterId.set(series.parameter_id, {
        parameter: {
          id: series.parameter_id,
          label: series.label ?? series.parameter_id,
          unit: config.unit,
        },
        data: {
          type: "TimeSeries",
          unit: config.unit,
          datapoints: [],
        },
      });
    }
  }

  return [...byParameterId.values()];
}
